import { render, staticRenderFns } from "./Create-Contact-Persons.vue?vue&type=template&id=86930d02"
import script from "./Create-Contact-Persons.vue?vue&type=script&lang=js"
export * from "./Create-Contact-Persons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports